import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-compare-pages-analysis',
  templateUrl: './compare-pages-analysis.component.html',
  styleUrls: ['./compare-pages-analysis.component.scss']
})
export class ComparePageAnalytic implements OnInit {

  @Input() dataReport: any
  title_report = 'SO SÁNH HÌNH THỨC BÀI ĐĂNG TRÊN FANPAGE THƯƠNG HIỆU';
  public brandListData = Array();

  public bubbleChartColors = [
    { backgroundColor: '#00b0f0' },
    { backgroundColor: '#c10e45' },
    { backgroundColor: '#04AA6D' }
  ]
  public bubbleChartType = 'bubble';
  public bubbleChartLegend = true;






  constructor() {
    console.log(this.dataReport)
  }

  ngOnInit(): void {
  };
  ngOnChanges(changes: SimpleChanges) {
    console.log(this.dataReport)
    this.mappingData()
    // changes.prop contains the old and the new value...
  }
  mappingData() {
    if (this.dataReport && this.dataReport.data) {
      if (this.dataReport.report_title) {
        this.title_report = this.dataReport.report_title;
      }

      this.brandListData = [];
      for (var i = 0; i < this.dataReport.data.length; i++) {
        let obj = {
          image: "data:image/jpeg;base64," + this.dataReport.data[i].image,
          linkCount: this.dataReport.data[i].linkCount, linkInteractiveCount: this.dataReport.data[i].linkInteractiveCount,
          photoCount: this.dataReport.data[i].photoCount, photoInteractiveCount: this.dataReport.data[i].photoInteractiveCount,
          videoCount: this.dataReport.data[i].videoCount, videoInteractiveCount: this.dataReport.data[i].videoInteractiveCount,
          bubbleChartData: [
            {
              data: [{ x: this.dataReport.data[i].photoInteractiveCount || 0, y: this.dataReport.data[i].photoCount, r: this.dataReport.data[i].photoCount }],
              label: 'Photo'
            },
            {
              data: [{ x: this.dataReport.data[i].videoInteractiveCount || 0, y: this.dataReport.data[i].videoCount, r: this.dataReport.data[i].videoCount }],
              label: 'Video'
            },
            {
              data: [{ x: this.dataReport.data[i].linkInteractiveCount || 0, y: this.dataReport.data[i].linkCount, r: this.dataReport.data[i].linkCount }],
              label: 'Link'
            }
          ],
          bubbleChartOptions: {
            responsive: true,
            scales: {
              xAxes: [
                {
                  ticks: {
                    min: 0,
                    max: this.dataReport.data[i].videoInteractiveCount > this.dataReport.data[i].photoInteractiveCount ? this.dataReport.data[i].videoInteractiveCount + 500 : this.dataReport.data[i].photoInteractiveCount + 500
                  }
                }
              ],
              yAxes: [
                {
                  ticks: {
                    min: 0,
                    max: this.dataReport.data[i].videoCount > this.dataReport.data[i].photoCount ? this.dataReport.data[i].videoCount * 1.5 : this.dataReport.data[i].photoCount * 1.5
                  }
                }
              ]
            }
          }
        };
        this.brandListData.push(obj);
      }
      // console.log(JSON.stringify(this.brandListData));
    }
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/compare-pages-analysis/compare-pages-analysis.component.ts